export default __webpack_public_path__ + "static/media/wave.023ea317.svg";